export default __webpack_public_path__ + "static/media/five.7c0c5813.svg";